export default `
width=800
"1963": "Event A"
"1965": "Event B"
"1966": "And Event C"
"1967": "Something else"
`